// Rucne vedeny seznam novinek, nejnovejsi prvni, zadna DB/API vrstva (stejny princip jako CHANGELOG.md).
// "img" je volitelny. "key" odkazuje na dashboard.news.entries.<key> - text zije v i18n, ne tady
// (data() se nepreklada, viz $t() reaktivita v News.vue).
//
// "key" je zaroven ID pouzivane pro sledovani "videno/nevideno" (viz store/modules/changelog,
// docs/superpowers/specs/2026-08-27-changelog-seen-tracking-design.md) - musi zustat stabilni,
// jednou pouzity klic uz nemenit ani neopakovat pro jinou polozku.
export const newsEntries = [
    {
        date: '2026-09-03',
        key: 'e60',
        img: require('@/assets/pic/news/trade-market-filters.png'),
    },
    {
        date: '2026-08-31',
        key: 'e59',
        img: require('@/assets/pic/news/pokedex-type-filter.png'),
    },
    {
        date: '2026-08-29',
        key: 'e58',
        img: require('@/assets/pic/web/mirror-pok.png'),
        // Jen ilustracni ikonka (mirror shield), ne screenshot zmeny - narozdil
        // od vetsiny novinek nema zabirat skoro celou sirku popupu (zadani
        // uzivatele 2026-08-29).
        imgWidthPercent: 35,
    },
    {
        date: '2026-08-29',
        key: 'e57',
        img: require('@/assets/pic/news/catch-button-glow.png'),
    },
    {
        date: '2026-08-29',
        key: 'e56',
        img: require('@/assets/pic/news/pokedex-caught-glow.png'),
    },
    {
        date: '2026-08-29',
        key: 'e55',
    },
    {
        date: '2026-08-29',
        key: 'e54',
        img: require('@/assets/pic/news/stadium-badge.png'),
    },
    {
        date: '2026-08-29',
        key: 'e53',
        img: require('@/assets/pic/news/dungeon-skill-used.png'),
    },
    {
        date: '2026-08-28',
        key: 'e52',
    },
    {
        date: '2026-08-28',
        key: 'e51',
    },
    {
        date: '2026-08-28',
        key: 'e50',
        img: require('@/assets/pic/news/heal-lifesteal-preselect.png'),
        // Zadani uzivatele 2026-08-28 - "zmenši ten obrázek na 90% šíře popupu" (ostatni
        // novinky maji obrazek na plnou sirku, viz NewsEntry.vue's imgWidthPercent default).
        imgWidthPercent: 90,
    },
    {
        date: '2026-08-28',
        key: 'e49',
        img: require('@/assets/pic/news/pokemon-picker.png'),
    },
    {
        date: '2026-08-27',
        key: 'e48',
        img: require('@/assets/pic/news/skill-dialog-header.png'),
    },
    {
        date: '2026-08-27',
        key: 'e46',
    },
    {
        date: '2026-08-24',
        key: 'e47',
        img: require('@/assets/pic/news/language-switcher.png'),
    },
    {
        date: '2026-08-19',
        key: 'e0',
        img: require('@/assets/pic/news/pvp-arena.png'),
    },
    {
        date: '2026-08-19',
        key: 'e1',
    },
    {
        date: '2026-08-19',
        key: 'e2',
        img: require('@/assets/pic/news/team-bottom-sheet-drag.png'),
    },
    {
        date: '2026-08-19',
        key: 'e3',
    },
    {
        date: '2026-08-19',
        key: 'e4',
    },
    {
        date: '2026-08-18',
        key: 'e5',
    },
    {
        date: '2026-08-18',
        key: 'e6',
    },
    {
        date: '2026-08-18',
        key: 'e7',
    },
    {
        date: '2026-08-17',
        key: 'e8',
        img: require('@/assets/pic/news/fight-report-redesign.png'),
    },
    {
        date: '2026-08-17',
        key: 'e9',
    },
    {
        date: '2026-08-17',
        key: 'e10',
    },
    {
        date: '2026-08-17',
        key: 'e11',
        img: require('@/assets/pic/news/notification-sound-catalog.png'),
    },
    {
        date: '2026-08-16',
        key: 'e12',
    },
    {
        date: '2026-08-16',
        key: 'e13',
    },
    {
        date: '2026-08-15',
        key: 'e14',
        img: require('@/assets/pic/news/trainer-tab.png'),
    },
    {
        date: '2026-08-14',
        key: 'e15',
    },
    {
        date: '2026-08-14',
        key: 'e16',
    },
    {
        date: '2026-08-14',
        key: 'e17',
    },
    {
        date: '2026-08-13',
        key: 'e18',
    },
    {
        date: '2026-08-13',
        key: 'e19',
    },
    {
        date: '2026-08-12',
        key: 'e20',
    },
    {
        date: '2026-08-12',
        key: 'e21',
    },
    {
        date: '2026-08-12',
        key: 'e22',
    },
    {
        date: '2026-08-12',
        key: 'e23',
    },
    {
        date: '2026-08-12',
        key: 'e24',
    },
    {
        date: '2026-08-12',
        key: 'e25',
    },
    {
        date: '2026-08-07',
        key: 'e26',
    },
    {
        date: '2026-08-07',
        key: 'e27',
    },
    {
        date: '2026-08-07',
        key: 'e28',
    },
    {
        date: '2026-08-06',
        key: 'e29',
    },
    {
        date: '2026-07-30',
        key: 'e30',
    },
    {
        date: '2026-07-25',
        key: 'e31',
    },
    {
        date: '2026-07-25',
        key: 'e32',
    },
    {
        date: '2026-07-25',
        key: 'e33',
    },
    {
        date: '2026-07-22',
        key: 'e34',
    },
    {
        date: '2026-07-22',
        key: 'e35',
    },
    {
        date: '2026-07-22',
        key: 'e36',
    },
    {
        date: '2026-07-21',
        key: 'e37',
    },
    {
        date: '2026-07-21',
        key: 'e38',
    },
    {
        date: '2026-07-21',
        key: 'e39',
    },
    {
        date: '2026-07-21',
        key: 'e40',
    },
    {
        date: '2026-07-20',
        key: 'e41',
    },
    {
        date: '2026-07-20',
        key: 'e42',
        img: require('@/assets/pic/news/rules-mobile.png'),
    },
    {
        date: '2026-07-19',
        key: 'e43',
        img: require('@/assets/pic/news/toplist-redesign.png'),
    },
    {
        date: '2026-07-19',
        key: 'e44',
        img: require('@/assets/pic/news/pokedex-redesign.png'),
    },
    {
        date: '2026-07-19',
        key: 'e45',
        img: require('@/assets/pic/news/skills-table.png'),
    },
];
